(() => {
  /* F13: load the "Complete the set" script (assets/mara-set.js) */
  if (!window.MaraSet && !document.querySelector('script[data-mara-set]') && document.currentScript) {
    const s = document.createElement('script');
    s.src = document.currentScript.src.replace(/mara-(home|product)\.js/, 'mara-set.js');
    s.defer = true; s.dataset.maraSet = '1';
    document.head.appendChild(s);
  }
  const root = document.getElementById('mh');
  if (!root) return;
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cartAdd = base + 'cart/add.js';
  const cartGet = base + 'cart.js';

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window && new IntersectionObserver((es) => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -10% 0px' });
  root.querySelectorAll('[data-reveal]').forEach(el => io ? io.observe(el) : el.classList.add('in'));

  /* Pack picker */
  const packForm = root.querySelector('[data-pack-form]');
  if (packForm) packForm.addEventListener('change', (e) => {
    const r = e.target.closest('input[type=radio]'); if (!r) return;
    root.querySelector('[data-pack-price]').textContent = r.dataset.price;
    root.querySelectorAll('[data-shot]').forEach(img => { img.hidden = img.dataset.shot !== r.dataset.shotTarget; });
  });

  /* Added-to-bag panel with a one-tap "Add a dragon for the road?" offer (one more bottle, same price) */
  const panel = root.querySelector('[data-added]');
  const upsell = panel.querySelector('[data-upsell]');
  const upBtn = panel.querySelector('[data-upsell-btn]');
  const upMsg = panel.querySelector('[data-upsell-msg]');
  const V1 = Number(panel.dataset.v1);
  let hideT;
  const setText = (t) => { panel.querySelector('[data-added-text] span').textContent = t; };
  const setCount = (n) => root.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.full = n > 0; });
  const addItem = async (id) => {
    const res = await fetch(cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
    const cart = await fetch(cartGet).then(r => r.json());
    setCount(cart.item_count);
    return { data, cart };
  };
  function showPanel(text, offer, keep) {
    setText(text);
    if (upsell) upsell.hidden = !offer;
    if (upMsg) upMsg.hidden = true;
    panel.hidden = false;
    setTimeout(() => panel.classList.add('show'), 20);
    clearTimeout(hideT);
    if (!offer && !keep) hideT = setTimeout(closePanel, 7000);
  }
  function closePanel() { clearTimeout(hideT); panel.classList.remove('show'); setTimeout(() => { panel.hidden = true; }, 400); }
  panel.querySelector('[data-added-close]').addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) closePanel(); });

  root.querySelectorAll('form[data-add]').forEach(form => form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type=submit]');
    const err = form.querySelector('.mh-err');
    const id = Number(new FormData(form).get('id'));
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    try {
      const { data, cart } = await addItem(id);
      const item = (data.items && data.items[0]) || {};
      const setShown = window.MaraSet ? await window.MaraSet.update(cart) : false;
      showPanel(`${item.product_title || 'Dragon Breath'}. ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in your bag.`, Boolean(!setShown && upsell && id === V1), setShown);
    } catch (x) {
      if (err) { err.textContent = `${x.message}. Please try again, or add it from the product page.`; err.hidden = false; }
      else { form.submit(); }
    } finally { btn.removeAttribute('aria-busy'); }
  }));

  if (upBtn) upBtn.addEventListener('click', async () => {
    upBtn.setAttribute('aria-busy', 'true');
    upMsg.hidden = true;
    try {
      const { cart } = await addItem(V1);
      upsell.hidden = true;
      setText(`One more dragon added. ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in your bag.`);
      hideT = setTimeout(closePanel, 7000);
    } catch (x) {
      upMsg.textContent = `${x.message}. Your first bottle is still in your bag.`;
      upMsg.hidden = false;
    } finally { upBtn.removeAttribute('aria-busy'); }
  });

  /* Video reel: tap to play with sound, one at a time */
  root.querySelectorAll('.mh-clip').forEach(clip => {
    const v = clip.querySelector('video'); const b = clip.querySelector('button');
    if (!v || !b) return;
    b.addEventListener('click', () => {
      root.querySelectorAll('.mh-clip.playing video').forEach(o => { if (o !== v) { o.pause(); } });
      v.muted = false; v.controls = true; v.preload = 'auto';
      clip.classList.add('playing');
      v.play().catch(() => {});
    });
    v.addEventListener('pause', () => { if (v.ended) { clip.classList.remove('playing'); v.controls = false; } });
  });
  const track = root.querySelector('[data-reel-track]');
  root.querySelectorAll('[data-reel]').forEach(btn => btn.addEventListener('click', () => {
    track.scrollBy({ left: Number(btn.dataset.reel) * track.clientWidth * 0.8, behavior: 'smooth' });
  }));

  /* Mobile buy bar: shows after the hero, hides while the pack picker is on screen */
  const bar = root.querySelector('[data-bar]');
  const hero = root.querySelector('#mh-hero'); const buy = root.querySelector('#buy');
  if (bar && hero && buy && 'IntersectionObserver' in window) {
    let heroOut = false, buyIn = false;
    const set = () => { const on = heroOut && !buyIn; bar.classList.toggle('show', on); bar.setAttribute('aria-hidden', String(!on)); bar.querySelector('button').tabIndex = on ? 0 : -1; };
    new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting; set(); }).observe(hero);
    new IntersectionObserver(([e]) => { buyIn = e.isIntersecting; set(); }, { threshold: 0.15 }).observe(buy);
  }
})();